"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("./index"));
var requestSource = null;
var version = "v1";
var _default = exports["default"] = {
  getView: function getView(viewId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _index["default"].get("/".concat(version, "/backoffice/views/").concat(viewId), {
      params: params
    });
  },
  getDiv: function getDiv(viewName, divName) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _index["default"].get("/".concat(version, "/backoffice/divs/").concat(viewName, "/").concat(divName), {
      params: params
    });
  },
  getItem: function getItem(id) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _index["default"].get("/".concat(version, "/backoffice/items/").concat(id), {
      params: params
    });
  },
  search: function search(viewId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (requestSource) {
      requestSource.cancel();
    }
    requestSource = _axios["default"].CancelToken.source();
    return _index["default"].get("/".concat(version, "/backoffice/views/").concat(viewId), {
      params: params,
      cancelToken: requestSource.token
    });
  }
};